// extracted by mini-css-extract-plugin
export default {"warnings--contents":"warnings_warnings--contents__ptrYC"};